module.exports = __webpack_public_path__ + "static/media/horizontal-ellipsis.a761df4d.svg";